import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import { Router} from '@angular/router';
import * as firebase from 'firebase';
import {ToastService} from '../typescripts/pro/alerts'
import {Ampa} from '../model/ampa';
import {AmpaService} from '../services/ampaService';

@Component({
  selector: 'app-adminampa-informacion',
  templateUrl: './adminampa-informacion.component.html',
  styleUrls: ['./adminampa-informacion.component.scss']
})

export class AdminampaInformacionComponent implements OnInit {

  //ampa;
  datosampa = [];
  datosdisponibles: boolean = false;
  user;
  userId = '';
  state;
  id;

  mostrarformulario = false;
  mostrarbotonanadirampa = false;
  mostrarselectorimagen = false;

  ampa: Ampa;
  //Definiendo ampa: Ampa ya tenemos la estructura de un Ampa
  /*nombre;
  direccion;
  direccionform
  telefono;
  lat;
  lng;
  url;
  email;
  codigo_postal;
  poblacion;
  provincia;
  date_registered;
  descripcion;
  imagen;// = 'https://firebasestorage.googleapis.com/v0/b/miampa-1be3e.appspot.com/o/compartido%2Fdefault-image.png?alt=media&token=1486414d-b17d-4789-a148-11c226f96c20';
*/

  optionsSelectTipo: Array<any>;
  public map: any = { lat: 39.944204, lng: 0.091394 };

  constructor(
    private router: Router,
    private ampaService: AmpaService,
    //private route: ActivatedRoute,
    private _location: Location,
    private toast: ToastService ) {
    console.log('constructor')

        //obtener datos del usuario admin logueado
        this.userId = localStorage.getItem('userId');
        console.log('UserId', this.userId);
        if(!this.userId){
          this.router.navigate[('')]
        } else {
          firebase.firestore().collection('admins').doc(this.userId)
          .get()
          .then((doc)=>{
            this.user = doc.data();
            console.log('User', this.user)
            console.log('User ampa ampa-informacion', this.user.ampa)
            //esto es una prueba rápida, quizás haya que modificar el código
            //toda la lógica de la vista hay que gestionarla en el componente,
            //el servicio "sólo" nos proporciona el ampa que andamos buscando
            this.ampa = this.ampaService.obtenerAMPAInformacion(this.user);
            //this.obtenerAMPAInformacion();
          })
        }
  }

   ngOnInit() {}

  // nos traemos los ampainformacion del ampa utilizando el id de ampa
  //que tiene el usuario en su documento
  obtenerAMPAInformacion(){
    console.log('obtenerAMPAInformacion')

    firebase.firestore().collection('ampas')
    .where('ampa','==', this.user.ampa)
    .get()
    .then(snapshot => {
      if (snapshot.size >0){
        this.mostrarbotonanadirampa = false;
        this.mostrarformulario = true;
        firebase.firestore().collection('ampas')
        .where('ampa','==', this.user.ampa)
        .get()
        .then(snapshot => {
            snapshot.forEach(doc => {
                var elemento = doc.data();
                console.log('ampainformacion: ',doc.data())
                if (elemento == undefined)
                        this.state = 'crear'
                else {
                  this.state = 'ver';
                  this.id = doc.id;

                  //En Elemento tenemos los datos del Ampa que necesitamos
                  //simplemente convertimos Elemento a un Ampa y lo metemos en this.ampa
                  this.ampa = elemento as Ampa;
                  /*
                  this.nombre= elemento.nombre || '';
                  this.direccion= elemento.direccion || '';
                  this.direccionform= elemento.direccionform || '';
                  this.telefono= elemento.telefono || '';
                  this.lat= elemento.lat || '';
                  this.lng= elemento.lng || '';
                  this.url= elemento.url || '';
                  this.email= elemento.email || '';
                  this.codigo_postal= elemento.codigo_postal || '';
                  this.poblacion= elemento.poblacion || '';
                  this.provincia= elemento.provincia || '';
                  this.date_registered= elemento.date_registered || '';
                  this.descripcion= elemento.descripcion || '';
                  this.imagen= elemento.imagen || 'https://firebasestorage.googleapis.com/v0/b/miampa-1be3e.appspot.com/o/compartido%2Fdefault-image.png?alt=media&token=1486414d-b17d-4789-a148-11c226f96c20';
                  */

                  this.datosampa = [...this.datosampa, elemento];
                  console.log('doc.id:', this.id)
                }
            });
        })
        .catch(err => {
            console.log('Error getting documents', err);
        });
      }
      else{
        this.mostrarbotonanadirampa = true;
        this.mostrarformulario = false;
      }
    })
    .catch(err => {
        console.log('Error obteniendo informacion ampa', err);
    });

    this.datosdisponibles = true;
  }


  // eliminar ampainformacion id
  eliminar(){
        firebase.firestore().collection('ampas').doc(this.id)
        .delete()
        .then(()=>{
          console.log('Borrado ceip ' + this.id)
          this.showSuccess('Datos eliminados correctamente.');
          this.datosampa = [];
          this.obtenerAMPAInformacion();
        })
        .catch(error => {
          console.log(error);
          this.showError('Error al eliminar los datos.');
        })
  }


  // actualizamos los datos de algunos campos del CEIP con this.id
  editar(){
    this.state = 'editar';
    console.log('editar ampa ampa:',this.user.ampa)
    console.log('editar ampa id:',this.id)
    this.router.navigate(['/admin/ampa-informacion/editar/' + this.id])
  }

  // volver a la url anterior
  volver(){
    this._location.back();
  }

  //metodos de toast para el usuario
  showSuccess(mensaje) {
    //let options = { closeButton: true, tapToDismiss: false,  titleClass: 'yellow' };
    //this.toast.success(mensaje, 'Toastr success!', options);
    this.toast.success(mensaje);
  }

  showError(mensaje) {
    //let options = { enableHtml: false,  positionClass: 'toast-bottom-right' };
    //this.toast.error(mensaje, 'Toastr error!', options);
    this.toast.error(mensaje);
  }

  showInfo(mensaje) {
    //let options = { extendedTimeOut: 30000, messageClass: 'pink' };
    //this.toast.info('Info message', 'Toastr info!', options);
    this.toast.info(mensaje);
  }

  showWarning(mensaje) {
    //let options = { progressBar: true,  timeOut: 3000,  toastClass: 'black'};
    //this.toast.warning('Warnig message', 'Toastr warning!', options);
    this.toast.warning(mensaje);
  }
}



// WEBPACK FOOTER //
// ./src/app/adminampa-informacion/adminampa-informacion.component.ts